define('../src/js/ensureGameParams',['require','exports','module','message-service/message-service','gameday-index-configurator/GamedayIndexConfigurator','gameday-index-url-hasher/UrlHasher','app-url/app-url'],function(require,exports,module){
    var dispatcher = require("message-service/message-service"),
        configManager = require("gameday-index-configurator/GamedayIndexConfigurator"),
        UrlHasher = require( "gameday-index-url-hasher/UrlHasher" ),
        appUrl = require( "app-url/app-url" );

    function updateGameParam(game){
        if(history.pushState){
            var url = appUrl(),
                queryParams = url.params;

            queryParams.gid = game;
            delete queryParams.mode;
            url.setProperty('params',queryParams);
            history.replaceState(queryParams,"",url.href);
        }
    }

    function updateGameHash(){
        var gameConfig = configManager.getGDConfig().data || {},
            hash = UrlHasher.getHashParams();
        
        if(!hash.game && gameConfig.game){
            hash.game = gameConfig.game;
            if(gameConfig.mode === "box"){
                hash.game_tab="box";
            }
        }
        UrlHasher.setHashParams(hash);
    }

    /* Incase we get old hash format */
    function cleanHash(){
        if(window.location.hash.indexOf('&')!==-1){
            var cleanHash = appUrl().hashParams;
            UrlHasher.setHashParams(cleanHash);
        }
    }
    return function(){
        cleanHash();
        updateGameHash();
        dispatcher.on("init_data_loaded",function(){
            updateGameParam(UrlHasher.getCachedParams().game);
        });
    }
});
